__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/369f62623ea5cbe710cf1fc5b1839d25bc3bfcdf7aecf733aa479e79/";